export default __webpack_public_path__ + "static/media/logo_icon.58f87680.png";